export const QA_NAME_MAP = 'map'

export const FIELD_ADDRESS_NAME = 'address'
